import { useState } from 'react'
import { createPortal } from 'react-dom'
import { toast } from 'react-toastify'

import { Dialog } from '@loadsmart/miranda-react'

import { formatAssignDriverDialogTitle } from '../../../presenters/trackingPresenter'
import { DriverForm } from './DriverForm'
import { DriverSelection } from './DriverSelection'

type AssignDriverDialogProps = {
  readonly open: boolean
  readonly carrierUUID: string
  readonly driverUUID?: string
  readonly shipmentUUID: string
  readonly onClose: () => void
  readonly onDriverAssigned: () => void
}

export function AssignDriverDialog({
  open,
  shipmentUUID,
  carrierUUID,
  driverUUID,
  onClose,
  onDriverAssigned,
}: AssignDriverDialogProps) {
  const [addingDriver, setAddingDriver] = useState(false)

  function handleSuccess() {
    toast.success('Driver assigned successfully')
    onDriverAssigned()
    onClose()
  }

  return createPortal(
    <Dialog open={open} data-testid="assign-driver-dialog" onClose={onClose}>
      <Dialog.Header>
        {formatAssignDriverDialogTitle(driverUUID)}
        <Dialog.Close data-testid="assign-driver-dialog-close" onClick={onClose} />
      </Dialog.Header>
      {addingDriver ? (
        <DriverForm
          carrierUUID={carrierUUID}
          shipmentUUID={shipmentUUID}
          onCancel={() => setAddingDriver(false)}
          onSave={handleSuccess}
        />
      ) : (
        <DriverSelection
          carrierUUID={carrierUUID}
          driverUUID={driverUUID}
          shipmentUUID={shipmentUUID}
          onAddNewDriver={() => setAddingDriver(true)}
          onCancel={onClose}
          onDriverAssigned={handleSuccess}
        />
      )}
    </Dialog>,
    document.body,
    'assign-driver-dialog-root'
  )
}
